import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { actionCreators } from '../redux/actions';
import { createPortal } from 'react-dom';
import { CoverageService } from '../../../services/coverageService';
import CoverageAppState from '../interfaces/CoverageAppState';

const Modal = () => {
  const dispatch = useDispatch();
  const coverageService = new CoverageService();
  const display = useSelector((state: CoverageAppState) => state.displayModal)
  const selectedPageId = useSelector((state: CoverageAppState) => state.selectedPageId)

  const toggleModal = () => dispatch(actionCreators.toggleModal());
  
  const deleteCoverageById = (pageId: number) => {
    pageId && coverageService.deleteCoverageById(pageId, res => {
      coverageService.getCoverages(res => {
        dispatch(actionCreators.setAllCoverages(res))
        toggleModal();
      }, res => console.error(res))
    }, res => {
      console.error(res)
    })
  }
  
  return (
    createPortal(
      <>
        {display && (
          <div className="bookmarks__modal" onClick={(event) => event.stopPropagation()}>
            <div className="bookmarks__modal-backdrop"></div>
            <div className="bookmarks__modal-innercontainer">
                <button onClick={toggleModal} className="modal__close">Stäng</button>
                <div className="modal__content">
                    <h2 className="modal__title">Ta bort bevakning?</h2>
                    <div className="button-group modal__button-group">
                        <button
                          className="genericBtn alternate"
                          onClick={toggleModal}
                          >
                          Avbryt
                        </button>
                        <button
                          className={'genericBtn primary'}
                          onClick={() => deleteCoverageById(selectedPageId)}
                          >
                          Ta bort
                        </button>
                    </div>
                </div>
            </div>
        </div>
        )}
      </>,
      document.body
    )
  );
}

export default Modal;